// The set of public pages a popup ad can be targeted to, plus the helper that
// maps the visitor's current route to one of those keys.

export interface PopupPageOption {
  value: string;
  label: string;
}

export const POPUP_PAGE_OPTIONS: PopupPageOption[] = [
  { value: "all", label: "All public pages" },
  { value: "home", label: "Home" },
  { value: "directory", label: "Directory / Search" },
  { value: "categories", label: "Categories" },
  { value: "locations", label: "Locations" },
  { value: "featured", label: "Featured listings" },
  { value: "business", label: "Business profiles" },
  { value: "tourist-spots", label: "Tourist spots" },
  { value: "listing-plans", label: "Listing plans" },
  { value: "contact", label: "Contact" },
];

/** Human label for a page key, for the admin list + chips. */
export function popupPageLabel(value: string): string {
  if (value === "all") return "All pages";
  return POPUP_PAGE_OPTIONS.find((o) => o.value === value)?.label || value;
}

/** Resolves the current route to a page key used for popup targeting. */
export function pageKeyFromPath(pathname: string): string {
  const p = (pathname.replace(/\/+$/, "") || "/").toLowerCase();
  if (p === "/") return "home";
  if (p.startsWith("/directory")) return "directory";
  if (p.startsWith("/categories") || p.startsWith("/category/")) return "categories";
  if (p.startsWith("/locations") || p.startsWith("/location/")) return "locations";
  if (p.startsWith("/featured-listings")) return "featured";
  if (p.startsWith("/business/")) return "business";
  if (p.startsWith("/tourist-spots") || p.startsWith("/spot/")) return "tourist-spots";
  if (p.startsWith("/listing-plans")) return "listing-plans";
  if (p.startsWith("/contact")) return "contact";
  return "other";
}